export const grafanaQueryKeys = {
  getMonitors: (params: {
    grafanaIntegrationName: string
    searchString: string
    teamId: string
  }) => ['grafana/monitors', params] as const
}
